import { render, staticRenderFns } from "./addressBookEntries.vue?vue&type=template&id=b32ad06c&scoped=true&"
import script from "./addressBookEntries.vue?vue&type=script&lang=js&"
export * from "./addressBookEntries.vue?vue&type=script&lang=js&"
import style0 from "./addressBookEntries.vue?vue&type=style&index=0&id=b32ad06c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32ad06c",
  null
  
)

export default component.exports